{
  "(optional)": "(opcionalno)",
  "(required)": "(obvezno)"
}